const headerText = {
  addProduct: "Ürün Ekle",
  account: "Hesabım",
  login: "Giriş yap",
};

export default headerText;
